import { IsNotEmpty, IsString } from 'class-validator';

export class TaxonomyReferenceItemDeleteRequest {
    @IsString()
    @IsNotEmpty()
    public uuid: string;

    constructor(data?: Partial<TaxonomyReferenceItemDeleteRequest>) {
        this.uuid = data && data.uuid;
    }
}
